/**
 * Formats an integer amount to a price string with euro symbol
 * @param amount - The amount in cents (integer)
 * @returns Formatted price string with euro symbol (e.g., "10,00€")
 */
export function formatAmountToEuro(amount: number): string {
    const euros = amount / 100;

    return `${euros.toFixed(2).replace('.', ',')}€`;
}

/**
 * Formats an amount already expressed in euros (e.g. the decimal strings
 * returned by the referral API) to a price string with euro symbol
 * @param amount - The amount in euros
 * @returns Formatted price string with euro symbol (e.g., "10,00€")
 */
export function formatEuros(amount: number): string {
    return `${amount.toFixed(2).replace('.', ',')}€`;
}
